module.exports = __webpack_public_path__ + "static/media/3v.43e59a2e.jpg";